<template>
  <div id="myPolls">
    <div v-if="isEmpty" class="dashboard-item cursor-default mt-3">
      <div class="info-header">
        <b> {{ $t('polls.welcomeToPoll') }} </b>
      </div>
      <div class="info-details mt-3">
        {{ $t('polls.notCreatedKulibriProject') }}
      </div>
      <div
        class="info-tutorial mt-3"
        v-html="$t('polls.createNewPollDescription')"
      ></div>
      <div class="info-new-poll-button mt-3">
        <Btn
          @click.native="$router.push('/pr/new')"
          :label="$t('create.btnCreate')"
          :icon="['fal', 'plus-circle']"
        />
      </div>
    </div>

    <div class="poll-with-details" v-else>
      <div class="py-3 dashboard-headline">
        <div class="button-parent">
          <div class="left">
            <select-field :options="optionsOwner" v-model="ownerSelection" />
            <div class="archieve-checkbox">
              <label for="checkbox">
                <input
                  type="checkbox"
                  class="tt"
                  v-model="chkIsArchive"
                />
                {{ $t('polls.lblDisplayArchivePoll')}}
              </label>
            </div>
          </div>
          <div class="right">
            <Btn
              @click.native="$router.push('/pr/new')"
              :label="$t('create.btnCreate')"
              :icon="['fal', 'plus-circle']"
            />
          </div>
        </div>
        <div v-if="0" class="row justify-content-around mt-3">
          <div class="col">
            <button
              type="button"
              @click="sortingKey = 'updated_at'"
              class="btn btn-primary btn-block btn-sm k-nav-button"
            >
              <font-awesome-icon :icon="['fal', 'clock']" />
            </button>
          </div>
          <div class="col">
            <button
              type="button"
              @click="sortingKey = 'participant_count'"
              class="btn btn-primary btn-block btn-sm k-nav-button"
            >
              <font-awesome-icon :icon="['fal', 'user']" />
            </button>
          </div>
          <button
            type="button"
            @click="sortingUp = !sortingUp"
            class="btn btn-primary btn-block btn-sm k-nav-button"
          >
            <font-awesome-icon v-if="sortingUp" :icon="['fas', 'chevron-up']" />
            <font-awesome-icon v-else :icon="['fas', 'chevron-down']" />
          </button>
        </div>
      </div>
      <template v-if="sortedPolls && sortedPolls.length > 0">
        <div
          class="dashboard-item card mb-2"
          v-for="(poll, index) in sortedPolls"
          :key="index"
          v-on:click="clickList(poll)"
          :style="pollImage(poll)"
        >
          <div class="dashboard-wrapper">

            <!-- deadline start -->
            <div
              v-if="pollInfoMessageUsingPollId(poll)"
              class="d-flex text-weight-semi-bold deadline"
            >
              <div
                :style="gridTheme"
                :class="[pollInfoMessageUsingPollId(poll).class]"
                class="legend-content text-size-12 flex-row mb-0"
              >
                <div class="mx-1">
                  <font-awesome-icon class="mx-1" :icon="pollInfoMessageUsingPollId(poll).icon" />
                  {{ pollInfoMessageUsingPollId(poll).text }}
                </div>
              </div>
            </div>
            <!-- deadline part end -->

            <div class="dashboard-type k-flex-row">
              <div class="k-flex-type type-info">
                <div class="poll-type">
                  <font-awesome-icon class="mr-1 ml-2" :icon="icon(poll.type)" />
                  <span> {{ polltype(poll.type) }} </span>
                </div>
                <span
                    v-if="poll.options.hiddenPoll"
                    class="text-size-18 text-center line-height-30"
                  >
                    <font-awesome-icon class="ml-2" :icon="['fal', 'eye-slash']" />
                </span>
              </div>
              <div class="archive-icon" @click.stop="openArchiveConfirmDiaglog(poll)">
                <font-awesome-icon :title="chkIsArchive ? $t('polls.undoArchiving') : $t('polls.archiveProject')" class="user-icon" :icon=" chkIsArchive ? ['fas', 'undo'] : ['fas', 'archive']">
                </font-awesome-icon>
              </div>
            </div>
            <div class="poll-details k-flex-details ml-2">
              {{createdInfo(poll)}}
            </div>
            <div class="dashboard-header ml-2">
              {{ poll.title }}
            </div>
            <div v-if="!isHiddenParticipantMode(poll)" class="ml-2 dashboard-count">
              <div v-if="poll.type == 2">
                <div
                  class="text-size-16 text-weight-semi-bold"
                >
                  {{ $t('event.statusInvitations') }}
                  <span class="mr-2"> {{ poll.openInvitations }} </span>
                  {{ $t('event.statusConfirmations') }}
                  <span class="text-success mr-2">
                    {{ poll.confirmations - poll.guests}} 
                    <span v-if="poll.options.limitedVotesPerEvent">
                    (+ {{ poll.guests }})
                    </span>
                  </span>
                  {{ $t('event.statusDeclines') }}
                  <span class="text-danger mr-2"> {{ poll.declines }} </span>
                </div>
              </div>
              <div v-else>
                {{ poll.participant_count }} {{ $t('polls.participants') }}
                <font-awesome-icon class="user-icon" :icon="['fas', 'user']" />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="dashboard-item card mb-2">
          <div class="dashboard-wrapper empty-dashboard-wrapper">
            <div class="dashboard-type k-flex-row">
              {{ getEmptyPollMessage() }}
            </div>
          </div>
        </div>
      </template>

    </div>

    <ModalConfirm
      v-show="confirmArchive"
      :msg="dialogMessage"
      @confirm="archivePoll()"
      :loading="isLoading"
      @cancel="confirmArchive = false"
    />
  </div>
</template>
<script>
import shared from '@/shared.js';
import { HTTP } from '@/shared/http';

import SelectField from '@/components/UI/SelectField';
import { pollMixin } from '@/components/mixins/PollMixins.js';
import { gridMixin } from './mixins/GridMixins';
import { mapState, mapGetters } from 'vuex';


function sprintf(format, ...args) {
  let i = 0;
  return format.replace(/%s/g, () => args[i++]);
}

export default {
  name: 'MyPolls',
  mixins: [pollMixin, gridMixin],
  props: {},

  components: {
    // 'v-select': vSelect,
    SelectField,
  },

  data() {
    return {
      mypolls: null,

      sortingKey: 'updated_at',
      sortingUp: false,
      ownerSelection: { code: 'all', label: this.$t('polls.lblAllPolls') },
      typeSelection: 'Alle',
      confirmArchive: false,
      dialogMessage: "",
      chkIsArchive: false,
      isLoading: false
    };
  },

  watch: {
    userName(newValue, oldValue) {
      // no action needed if setting or resetting the user
      if (!newValue || !oldValue) return;
      console.error('Updating User name from:', oldValue, newValue);

      if (!this.user) {
        // the user was logged out
        return;
      }
      for (const poll of this.mypolls) {
        if (poll.user_id == this.user.id) {
          poll.user_name = newValue;
        }
      }
      localStorage.setItem('polls', JSON.stringify(this.mypolls));
    },

    defaultSelection(newValue) {
      this.ownerSelection = newValue;
    },
  },
  methods: {
    sortBy(key) {
      if (this.sortingKey == key) {
        this.sortingUp = !this.sortingUp;
      }
      this.sortingKey = key;
    },

    pollImage(poll) {
      let imagePath = poll.bg_image_path;
      if(poll.bg_image_path) {
        if(poll.bg_image_path.includes("/images/") == true) {
          imagePath = poll.bg_image_path.replace('/images/', '/images/sm_');
        } else if(poll.bg_image_path.includes("/storage/") == true) {
          imagePath = poll.bg_image_path.replace('/storage/', '/storage/sm_');
        }
      } else {
        imagePath = this.bgDefaultImage.url.replace('/images/', '/images/sm_')
      }
      let bgStyle = `background-image: url('${imagePath}')`;
      return bgStyle;

    },

    lastUpdate(poll) {
      if (poll.updated_at == null) {
        return shared.lastUpdate(poll.created_at, this.$t);
      }
      return shared.lastUpdate(poll.updated_at, this.$t);
    },

    createdInfo(poll) {
      const isMyPoll = poll.user_id === this.userId;
      const userName = isMyPoll ? this.$t('general.me') : poll.user_name;
      const info = sprintf(
        this.$t('polls.created'),
        userName,
        this.lastUpdate(poll)
      );
      return info;
    },

    clickList(poll) {
      console.log('clickList fired with ' + poll.id);
      this.$router.push({ path: `/pr/${poll.url_part}` }); // -> /user/123
    },

    isHiddenParticipantMode(poll) {
      //console.log('isHiddenParticipantMode:', poll);
      if (!poll.options.hiddenPoll) return false;
      if (poll.user_id === this.userId) return false;
      return true;
    },
    getEmptyPollMessage() {
      if (this.ownerSelection.code === 'my') {
        return this.$t('polls.noMyProject');
      } else if (this.ownerSelection.code === 'others') {
        return this.$t('polls.noOtherProject');
      }
    },
    pollInfoMessageUsingPollId(poll) {
      if (poll.closed) {
        let text = this.$t('close.status');
        if (poll.type == 2) {
          text = this.$t('close.statusEvent');
        }
        return {
          class: 'bg-closed',
          icon: ['fas', 'lock'],
          text: text,
        };
      }

      if (!poll.deadline) return null;
      if (this.isDeadlinePassedOfPoll(poll))
        return {
          //class: 'bg-passed-deadline text-white',
          class: 'bg-closed',
          icon: ['fal', 'clock'],
          text:
            this.$t('close.statusPassedDeadline') +
            this.deadlineDateOfPoll(poll) +
            ' (' +
            this.$t('general.timeZone') +
            ':' +
            Intl.DateTimeFormat().resolvedOptions().timeZone +
            ')',
        };

      return {
        class: 'bg-closed',
        icon: ['fal', 'clock'],
        text:
          this.$t('close.statusDeadline') +
          this.deadlineDateOfPoll(poll) +
          ' (' +
          this.$t('general.timeZone') +
          ':' +
          Intl.DateTimeFormat().resolvedOptions().timeZone +
          ')',
      };
    },
    isDeadlinePassedOfPoll(poll) {
      if (!poll.deadline) return false;

      const today = new Date();
      let deadline = new Date(poll.deadline);
      deadline.setDate(deadline.getDate());
      //console.log('isDweadlinePassed:', today, deadline);
      return today > deadline;
    },
    deadlineDateOfPoll(poll) {
      if (!poll.deadline) return null;
      // let deadline = this.fullWeekDay(poll.deadline) + ' ';
      // deadline += this.dayMonthYear(poll.deadline);
      // return deadline;
      const locale = this.$i18n.locale;
      const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      };
      return new Date(poll.deadline).toLocaleString(locale, options);
    },
    openArchiveConfirmDiaglog(poll) {
      this.confirmArchive = true;
      this.currentSelectedPoll = poll;
      this.dialogMessage = poll.isArchive ? this.$t('polls.confirmRetrieveMessage') : this.$t('polls.confirmArchiveMessage');
    },
    archivePoll() {
      this.isLoading = true;
      const url = process.env.VUE_APP_API_URI_SEGMENT + '/poll/' + this.currentSelectedPoll.id + '/archive';

      HTTP.put(url)
      .then((response) => {
        this.currentSelectedPoll.isArchive = response.data.isArchive;
        this.confirmArchive = false;
        this.isLoading = false;
      })
      .catch((error) => {
        this.isLoading = false;
        console.log(error);
      });
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.Login.user,
    }),

    ...mapGetters({
      isAuthenticated: 'isAuthenticated',
      userName: 'userName',
      userId: 'userId',
      isOwner: 'isOwner',
      bgDefaultImage: 'bgDefaultImage'
    }),

    // defaultSelectionValue() {
    //   let selection = { code: 'all', label: this.$t('polls.lblAllPolls') };
    //   return selection;
    // },

    isEmpty() {
      if (this.mypolls == null || this.mypolls.length == 0) {
        return true;
      }
      return false;
    },
    optionsOwner() {
      let options = [
        { code: 'all', label: this.$t('polls.lblAllPolls') },
        { code: 'my', label: this.$t('polls.lblMyPolls') },
        { code: 'others', label: this.$t('polls.lblFromOthers') }
      ];
      return options;
    },

    optionsType() {
      let options = [
        { code: 'all', label: 'Alle ' },
        { code: 'my', label: 'Terminfindung' },
        { code: 'others', label: 'Events' },
        { code: 'others', label: 'Umfragen' },
      ];
      return options;
    },

    selectedPolls() {

      // if (this.chkIsArchive == true) {
      //   let mypolls = this.mypolls.filter((p) => p.isArchive == 1);
      //   return mypolls;
      // }

      if (this.ownerSelection.code === 'my') {
        let mypolls = this.mypolls.filter((p) => p.user_id === this.userId && p.isArchive == this.chkIsArchive);
        return mypolls;
      }

      if (this.ownerSelection.code === 'others') {
        let mypolls = this.mypolls.filter((p) => p.user_id != this.userId && p.isArchive == this.chkIsArchive);
        return mypolls;
      }

      let mypolls = this.mypolls.filter((p) => p.isArchive == this.chkIsArchive);
      return mypolls;

      // return this.mypolls;
    },

    sortedPolls() {
      if (!this.mypolls) return null;

      let mypolls = this.selectedPolls;

      let polls = mypolls.concat().sort((pollA, pollB) => {
        if (pollA[this.sortingKey] > pollB[this.sortingKey]) {
          return 1;
        }
        if (pollA[this.sortingKey] < pollB[this.sortingKey]) {
          return -1;
        }
        return 0;
      });

      if (this.sortingUp) {
        return polls;
      }

      return polls.reverse();
    },
  },

  mounted() {
    //this.lastUpdate = shared.lastUpdate; // now you can call this.foo() (in your functions/template)
    const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
    const url = apiUrl + '/polls';
    console.log('Using the followingUrl:' + url);

    let tokenStr = localStorage.getItem('token');
    console.log('use token:' + tokenStr);

    const polls = localStorage.getItem('polls');
    if (polls) {
      console.log('read polls from local storage');
      this.mypolls = JSON.parse(polls);
    }

    HTTP.get(url)
      .then((response) => {
        console.log('Processing the loaded polls:', response);
        this.mypolls = response.data;
        localStorage.setItem('polls', JSON.stringify(this.mypolls));
      })
      .catch((error) => console.log(error));
  },
};
import '@/styles/select-variables.scss';
import 'vue-select/src/scss/vue-select.scss';
</script>

<style lang="scss" scoped>
@import '@/styles/style.scss';

.dashboard-headline,
.dashboard-item {
  max-width: 800px;
}

.dashboard-item {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  color: $white;
  border-radius: 9px;
  cursor: pointer;
}

.dashboard-wrapper {
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
}

.dashboard-header {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  margin-bottom: 8px;
  // width: 50%;
  font-size: $large;
  font-weight: $semi-bold-weight;
  color: $white;
  line-height: 30px;
  white-space: pre-line;
}

.dashboard-count {
  // text-align: right;
  font-size: $big;
  color: $white;
  font-weight: $regular-weight;
  line-height: 18px;

  svg {
    height: 13px;
    width: 12px;
  }
}

th,
tr {
  text-align: left !important;
}

ul {
  display: flex;
  flex-wrap: wrap;
  list-style-type: none;
  padding: 0;
}
li {
  flex-grow: 1;
  flex-basis: 300px;
  text-align: center;
  padding: 30px;
  border: 1px solid #222;
  margin: 10px;
}

.table-row {
  cursor: pointer;
}

.btn {
  text-transform: none;
}

.text-event {
  color: $date-color;
}

.text-survey {
  color: rgb(29, 247, 0);
}

.k-type-select {
  background-color: white;
}

.poll-type {
  font-size: $big-extra;
  color: $white;
  font-weight: $regular-weight;

  svg {
    vertical-align: -0.125em !important;
    font-weight: $semi-bold-weight;
    height: 20px;
    width: 15px;
  }
}

.poll-details {
  font-size: $small;
  line-height: 14px;
  color: $white;
  font-weight: $regular-weight;
  // margin-top: 8px;
}

.button-parent {
  width: 100%;
  text-align: center;
  display: inline-block;
}

.left {
  float: left;
  display: flex;
}

.right {
  float: right;
}

.info-header,
.info-details,
.info-tutorial {
  color: $dark-grey;
}

.cursor-default {
  cursor: default;
}

.info-header {
  font-size: $standard;
}

.info-details,
.info-tutorial {
  font-size: $small;
}

.profile-btn-link {
  cursor: pointer;
}

.user-icon {
  margin-bottom: 2px;
}

.empty-poll {
  font-size: 16px;
  color: $primary;
  padding: 10px;
}

.empty-dashboard-wrapper {
  background-color: $mid-grey;
}

.deadline {
  color: $dark-grey
}

@media screen and (max-width: 480px) {
  ::v-deep .left {
    display: unset;
    #dropdownMenuButton, .dropdown-menu {
      width: 120px;
    }
  }
  ::v-deep .archieve-checkbox {
    margin-top: 6px !important;
    margin-left: 0 !important;
  }
  ::v-deep .archive-icon {
    .user-icon {
      vertical-align: bottom !important;
    }
  }
}

.type-info {
  width: 100%;
  display: flex;
}
.archieve-checkbox {
  font-size: $very-small;
  width: 100%;
  margin: auto;
  margin-left: 0.5rem;

  [type="checkbox"]
  {
    vertical-align: text-bottom;
    width: 16px;
    height: 16px;
  }

  label {
    margin-bottom: unset;
    white-space:nowrap;
  }
}
.archive-icon {
  width: 32px;
  background-color: $primary;
  text-align: center;
  border-radius: 5px;
  height: 32px;
  .user-icon {
    width: 16px;
    vertical-align: middle;
    margin: 0;
  }
}
</style>
